import React from 'react';
import { Employee as EmployeeData } from '../../data/employees.val';
import Body from '../Body/Body';
import { ValImage } from '@valbuild/next';
import { val } from '../../val.config';

export interface EmployeeProps {
  employee: EmployeeData;
}

const Employee = ({ employee }: EmployeeProps) => {
  return (
    <div
      className="flex flex-col items-start gap-8 tablet:gap-12"
      {...val.attrs(employee)}
    >
      <div className={`w-full relative h-[513px]`}>
        <ValImage
          className={`object-cover`}
          src={employee.image}
          fill
          sizes={'1200px'}
        />
      </div>
      <div className="space-y-4">
        <Body className={`text-xl`}>{val.raw(employee.name)}</Body>
        <a
          href={`mailto:${val.raw(employee.email)}`}
          className="no-underline text-md"
        >
          {val.raw(employee.email)}
        </a>
      </div>
    </div>
  );
};

export default Employee;
